<template lang="html">
  <div>
    <v-dialog
      v-model="AddbotDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card :style="stylechat">
      <!-- start -->
      <div class="pa-1">
        <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
          <v-col
            cols="2"
            justify="center"
            align="start"
            class="pr-0 pt-0 pb-0"
            @click="close()"
          >
            <v-icon class="fz-30">mdi-close</v-icon>
          </v-col>
          <v-col
            cols="8"
            justify="center"
            align="center"
            class="pa-0"
          >
            <span class="tab-title">{{$t('AnswerQuestion.addFriend')}}</span>
          </v-col>
          <v-col
            cols="2"
            justify="center"
            align="center"
            class="pr-2 pl-0 pt-0 pb-0"
            >
          </v-col>
        </v-layout>
        <v-divider class="mt-4 mb-2"></v-divider>
        <v-layout row wrap justify-center align-center class="mt-3 pl-5 pr-5 pb-5">
          <v-col cols="12" justify="center" align="center">
            <v-avatar size="100">
              <img v-if="BotDetail.user.profilepicture" :src="BotDetail.user.profilepicture" :alt="BotDetail.user.nickname" class="img-position">
              <!-- <img v-else-if="BotDetail.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" class="img-position" :alt="BotDetail.user.nickname"> -->
              <img v-else :src="`${publicPath}/assets/img/default_profile/bot-white.png`" class="img-position" :alt="BotDetail.user.nickname">
            </v-avatar>
          </v-col>
          <v-col cols="12" justify="center" align="center">
            <h2>{{BotDetail.user.nickname}}</h2>
          </v-col>
          <v-col cols="12" justify="center" align="center">
            <v-btn class="btn-confirm" @click="toPage()">{{text_btn}}</v-btn>
          </v-col>
        </v-layout>
      </div>
    </v-card>
    <Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <PasswordBot :PasswordBotDialog="PasswordBotDialog" :PasswordBotDetail="PasswordBotDetail" @closeDialog="closeDialog"/>
  </v-dialog>
</div>
</template>

<script>
import { Momenttime } from '@/services'
import Warning from '@/components/Alert/Warning'
import ErrorAlert from '@/components/Alert/Error'
import PasswordBot from '@/components/PasswordBot'
var _ = require('lodash')
export default {
  props: {
    AddbotDialog: Boolean,
    BotDetail: {}
  },
  data () {
    return {
      PasswordBotDetail: {},
      PasswordBotDialog: false,
      text_btn: '',
      status_note: 'active',
      AddbotDetail: {},
      publicPath: process.env.VUE_APP_BASE_PATH,
      EditBotDetail: {},
      EditAddbotDialog: false,
      data_note_edit: '',
      data_note: '',
      ListBottomMenu: false,
      ListBottomItem: [],
      ErrorDialog: false,
      ErrorDialogDetail: {},
      WarningDialog: false,
      WarningDialogDetail: {},
      list_note: [],
      status_edit: 'start',
      progress: false,
      data_user: {},
      stylechat: {
        "--Addbot-HeaderColor": "white",
        "--Addbot-TabBackground": "white",
        "--Addbot-Icon": "gray",
        "--Addbot-IconActive": "#2662ae",
        "--Addbot-Background": "white",
        "--Addbot-FontSize": "18px",
        "--Addbot-FontSize-Title": "24px",
        "--Addbot-FontColor": "back",
        "--Addbot-FontSize-Status": "16px",
        "--Addbot-FontColor-Status": "grey",
        "--Addbot-Background-Input": "#E2E1E3",
        "--Addbot-Color-Button": "#EFF2FE",
        "--Addbot-FontColor-Button": "#2662ae",
        "--Addbot-FontColor-Block-Button": "#cb1002",
        "--Addbot-FontColor-Dis-Button": "#e2e1e3",
        "--Addbot-Btn-Confirm-Background": "#2662ae",
        "--Addbot-Btn-Confirm-Color": "white",
        "--Addbot-Btn-Confirm-FontSize": "18px",
        "--Addbot-Btn-Cancel-Background": "white",
        "--Addbot-Btn-Cancel-Color": "#2662ae",
        "--Addbot-Btn-Cancel-FontSize": "18px",
        "--Addbot-Btn-Leave-Background": "white",
        "--Addbot-Btn-Leave-Color": "#ff5252",
        "--Addbot-Btn-Leave-FontSize": "18px",
        "--Addbot-FontSize-Title-Edit": "20px"
      },
    }
  },
  components: {
    ErrorAlert,
    Warning,
    PasswordBot,
  },
  watch: {
    AddbotDialog () {
      if (this.AddbotDialog) {
        var user_profile = ''
        if (JSON.parse(this.$cookie.get('user-profile') == null)) {
          user_profile = JSON.parse(localStorage.getItem('user-profile'))
        } else {
          user_profile = JSON.parse(this.$cookie.get('user-profile'))
        }
        // console.log(user_profile)
        this.data_user = user_profile['account']['profile']
        // console.log(this.data_user)
        // console.log(this.BotDetail)
        if (this.BotDetail.relation === 'friend') {
          this.text_btn = this.$t('AnswerQuestion.chat')
        } else if (this.BotDetail.relation === 'unknown' || this.BotDetail.relation === 'unfriend' || this.BotDetail.relation === 'unknow') {
          this.text_btn = this.$t('AnswerQuestion.addFriend')
        } else if (this.BotDetail.relation === 'block') {
          this.text_btn = this.$t('AnswerQuestion.unblock')
        }
        // this.getNote()
      }
    }
  },
  created () {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    // console.log(user_profile)
    this.data_user = user_profile['account']['profile']
    // console.log(this.data_user)
  },
  methods: {
    closeDialog () {
      this.PasswordBotDialog = false
    },
    toPage () {
      if (this.BotDetail.relation === 'friend') {
        this.$router.push(`/chat/${this.BotDetail.user.tokenroom}`)
      } else if (this.BotDetail.relation === 'unknow' || this.BotDetail.relation === 'unknown' || this.BotDetail.relation === 'unfriend') {
        this.AddFriend()
      } else if (this.BotDetail.relation === 'block') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Unblocking', { name: this.BotDetail.user.nickname}),
          detail: this.BotDetail,
          index: 0,
          type: 'unblock'
        }
        this.WarningDialog = true
      }
    },
    AddFriend () {
      // console.log('AddFriend: ', this.BotDetail.user.is_password)
      if (this.BotDetail.user.is_password !== '0') {
        // open dilog password
        this.PasswordBotDetail = this.BotDetail
        this.PasswordBotDialog = true
      } else {
        this.axios.post(process.env.VUE_APP_API_GO + `/v1/add-friend`, {
          tokenfriend: this.BotDetail.user.tokenuser,
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          // console.log(response.data);
          if (response.data.status === 'success') {
            this.BotDetail.relation = 'friend'
            this.BotDetail.user.tokenroom = response.data.tokenroom
            this.text_btn = this.$t('AnswerQuestion.chat')
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      }
    },
    unBlockFriend (data) {
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/unblockfriend`, {
        tokenuser: this.data_user.tokenuser,
        tokenroom: data.user.tokenroom,
        tokenfriend: data.user.tokenuser
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.BotDetail.relation = 'friend'
          this.text_btn = this.$t('AnswerQuestion.chat')
          // console.log(this.BotDetail.relation)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err.response.data)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    closeComponents (data) {
      // console.log(data)
      if (data.name === 'edit-note') {
        this.EditAddbotDialog = data.value
      } else if (data.name === 'detail-note') {
        this.DetailAddbotDialog = data.value
      } else if (data.name === 'Addbot') {
        this.AddbotDialog = data.value
      }
    },
    emitListBottom (value) {
      // console.log(value)
      this.ListBottomMenu = false
      if (value.item.actions === 'delete-note') {
        this.openDialog(value.item, value.item.index, 'delete-note')
      } else if (value.item.actions === 'detail-note') {
        this.EditBotDetail = value.item.item
        this.EditAddbotDialog = true
      }
    },
    date (timestamp) {
      return Momenttime.dayjsdatethai(timestamp)
    },
    time (timestamp) {
      return Momenttime.dayjstimethai(timestamp)
    },
    close () {
      this.data_note = ''
      this.$emit('closeComponents', {
        name: 'detail-bot',
        value: false
      })
    },
    emitWarning (item) {
      // console.log(item)
      this.WarningDialog = false
      if (item.type === 'unblock') {
        // this.deleteNote(item.detail.id, item.index)
        this.unBlockFriend(item.detail)
      }
    },
    closeAlertDialog (data) {
      // console.log(data)
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      } else if (data.type === 'bottommenu') {
        this.ListBottomMenu = data.value
      }
    },
    deleteNote (id, index) {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/removenote`, {
        note_id: id,
        tokenuser: this.data_user.tokenuser
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.$emit('emitComponents', { name: 'detail-note', value: false })
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
  }
}
</script>

<style lang="css" scoped>
.height-100 {
  height: 100vh;
}
.height-80 {
  height: 80vh;
}
.fz-18 {
  font-size: 18px !important;
}
.fz-20 {
  font-size: 20px !important;
}
.fz-60 {
  font-size: 60px !important;
}
.fz-80 {
  font-size: 80px !important;
}
.text-btn {
  color: var(--Addbot-FontColor-Button) !important
}
.text-btn-disable {
  color: var(--Addbot-FontColor-Dis-Button) !important
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
.font-list-title {
  font-weight: 600;
  color: var(--Addbot-FontColor) !important;
}
.width-100 {
  width: 100% !important;
}
.fz-30 {
  font-size: 30px !important;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--Addbot-FontSize-Title) !important;
  color: var(--Addbot-FontColor) !important;
  font-weight: 600;
}
.text-title-edit {
  font-size: var(--Addbot-FontSize-Title-Edit) !important;
  color: var(--Addbot-FontColor) !important;
}
.tab-title {
  color: var(--Addbot-FontColor) !important;
  font-size: var(--Addbot-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--Addbot-FontColor-Status) !important;
  font-size: var(--Addbot-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
.checkbox-color {
  color: var(--Addbot-IconActive) !important;
}
>>>.v-application .elevation-10 {
  box-shadow: none !important;
}
>>>.theme--light.v-sheet {
  box-shadow: none !important;
}
.list-overflow {
  height: calc(100vh - 64px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
  height: calc(100vh - 210px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow-select::-webkit-scrollbar {
  width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-input__slot {
  background-color: var(--Addbot-Background-Input) !important;
  border-radius: 10px !important;
} */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  background-color: var(--Addbot-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--Addbot-Icon) !important;
}
.icon-color {
  color: var(--Addbot-IconActive) !important;
}
.btn-confirm {
  background-color: var(--Addbot-Btn-Confirm-Background) !important;
  color: var(--Addbot-Btn-Confirm-Color) !important;
  font-size: var(--Addbot-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--Addbot-Btn-Cancel-Background) !important;
  color: var(--Addbot-Btn-Cancel-Color) !important;
  font-size: var(--Addbot-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--Addbot-Btn-Leave-Background) !important;
  color: var(--Addbot-Btn-Leave-Color) !important;
  font-size: var(--Addbot-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--Addbot-Background) !important;
}

.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--Addbot-FontSize-Title) !important;
  color: var(--Addbot-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--Addbot-FontColor) !important;
  font-size: var(--Addbot-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--Addbot-FontColor-Status) !important;
  font-size: var(--Addbot-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
</style>
